import { FiX } from 'react-icons/fi';
import ShopFilters from '../../components/shop/ShopFilters';

export const ShopMobileFilters = ({ open, onClose, filterProps }) => {
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Filters"
      className="lg:hidden fixed inset-0 z-50"
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Close filters overlay"
        className="absolute inset-0 w-full h-full bg-black/40 cursor-default"
      />
      <aside className="absolute left-0 top-0 flex h-full w-80 max-w-[88vw] flex-col overflow-hidden bg-white shadow-2xl">
        <header className="flex min-h-16 shrink-0 items-center justify-between gap-3 border-b border-gray-200 bg-gray-50 px-4 py-2.5">
          <h2 className="text-base font-semibold text-gray-900">Filters</h2>
          <div className="flex shrink-0 items-center gap-2">
            <button
              type="button"
              onClick={filterProps.onClearAll}
              className="min-h-10 whitespace-nowrap rounded-lg px-3 text-sm font-medium text-orange-600 transition-colors hover:bg-orange-50 hover:text-orange-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
            >
              Clear all
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-900 shadow-sm transition-colors hover:border-gray-400 hover:bg-gray-100 hover:text-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-700"
              aria-label="Close filters"
            >
              <FiX className="text-2xl" strokeWidth={2.5} aria-hidden="true" />
            </button>
          </div>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
          <ShopFilters {...filterProps} hideHeader />
        </div>

        <div className="mt-auto shrink-0 border-t border-gray-100 bg-white p-4">
          <button
            onClick={onClose}
            className="min-h-11 w-full rounded-lg bg-orange-500 py-2.5 text-sm font-medium text-white transition-colors hover:bg-orange-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2"
          >
            Show Results
          </button>
        </div>
      </aside>
    </div>
  );
};
